<template>
  <select
      class="table-select"
      v-model="item.values"
  >
    <option
        v-for="(option) in item.keyRange"
        :value="option"
    >
      {{option.title}}
    </option>
  </select>
</template>
<script>
export default {
  name: 'SelectOptionBox',
  props: ['item']
}
</script>
<style lang="scss">
.table-select {
  select:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>